import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentEmpid, selectCurrentUserManagerLevel } from '../../../pages/login/authSlice';
import { useGetCoachingSummaryQuery } from '../coachingSlice';
import { ROLES } from '../../../constants';

interface TriadHeaderProps {
    inputMonth: number | undefined;
    inputYear: number | undefined;
    hirearchy: any;
    handleSelectedEmploye: (e: any) => void;
    handleDateChange: (e: any) => void;
    created: boolean;
    triadsList: any;
    date: Date;
    userRole: string;
    graphSelectedEmployee: string | null;
    triadPageNev: number;
    handleIsConfigured: (isConfigured: boolean) => void;
}

export const TriadHeader = (props: TriadHeaderProps) => {
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);
    const [triadDate, setTriadDate] = useState<Date | string>('');
    const [selectedAssociate, setSelectedAssoicate] = useState<any>(null);
    const [associateList, setAssociateList] = useState<any>([]);

    const { data: triadEmployee } = useGetCoachingSummaryQuery(
        {
            employeeNumber: props?.hirearchy.teamLeadId,
            year: props?.inputYear,
            month: props?.inputMonth,
            flag: false, // true for tl and false Manager
            loggedEmpRole: props?.userRole,
        },
        {
            skip: !props?.hirearchy.teamLeadId || !props?.inputYear || !props?.inputMonth,
        }
    );

    useEffect(() => {
        if (triadEmployee?.data?.length > 0) {
            if (ROLES.Supervisor2AndAbove.includes(userManagerLevel)) {
                const filterOutOwnRec = triadEmployee?.data?.filter(
                    (record: any) => ROLES.Agents.includes(record.manager_level)
                );
                setAssociateList(filterOutOwnRec);
            } else {
                setAssociateList(triadEmployee?.data);
            }
        }
    }, [triadEmployee]);

    useEffect(() => {
        if (props?.hirearchy.associateId && triadEmployee?.data) {
            setSelectedAssoicate(props?.hirearchy.associateId);
            props?.handleSelectedEmploye(props?.hirearchy.associateId);
        }
    }, [associateList]);

    useEffect(() => {
        if (props?.graphSelectedEmployee) {
            setSelectedAssoicate(props?.graphSelectedEmployee);
        }
    }, [props?.graphSelectedEmployee]);

    useEffect(() => {
        if (props?.date) {
            setTriadDate(props?.date);
        }
    }, [props?.date]);

    const renderValue = () => {
        return props?.triadsList.length > 0 ? props?.triadsList[props?.triadPageNev]?.manager : loggedEmpNum;
    };

    const handleAssociateChange = (e: any) => {
        setSelectedAssoicate(e.value);
        props?.handleSelectedEmploye(e.value);
        const isConfigured = associateList?.find((emp: any) => emp.employee_number === e.value)?.isConfigured;
        props?.handleIsConfigured(isConfigured);
    };

    return (
        <div className="row">
            <div className="col-md-3">
                <div className="content">
                    <label htmlFor="countryId">Month</label>
                    <Calendar
                        id="basic"
                        view="month"
                        dateFormat="MM, yy"
                        disabled={props?.created}
                        onChange={props?.handleDateChange}
                        value={triadDate}
                        showIcon
                        className="custom-calendar"
                    />
                </div>
            </div>
            <div className="col-md-3">
                <div className="content">
                    <label htmlFor="recipientName">Author</label>

                    <InputText disabled readOnly={false} value={renderValue()} />
                </div>
            </div>

            <div className="col-md-3">
                <div className="content">
                    <label htmlFor="recipientName">Team Lead</label>

                    <InputText disabled readOnly={false} value={props?.hirearchy.teamLead} />
                </div>
            </div>
            <div className="col-md-3">
                <div className="content">
                    <label htmlFor="countrydd">Associate</label>
                    <Dropdown
                        id="employee_number"
                        placeholder="Associate"
                        className="custom-dropdown"
                        options={associateList}
                        optionValue={'employee_number'}
                        optionLabel={'employee_name'}
                        aria-label="associate"
                        disabled={props?.created}
                        value={selectedAssociate}
                        onChange={handleAssociateChange}
                    />
                </div>
            </div>
        </div>
    );
};
